import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20px 0 0;
`
export const DataSourceIcon = styled.img`
  width: 40px;
  height: 40px;
`
export const DataSourceText = styled.p`
  font-size: 0.85rem;
  color: #494B6A;
  margin-top: 0.4rem;
`
